<template>
  <div
    class="relative flex flex-col lg:flex-row items-center px-6 max-w-screen-sm md:max-w-screen-2xl mx-auto"
  >
    <div
      class="relative w-full flex flex-col md:flex-row justify-start md:justify-between min-h-[1000px]"
    >
      <div class="md:absolute right-0 py-6 z-10">
        <div class="flex flex-col gap-5 items-center md:items-end">
          <div
            v-for="(card, index) in cards"
            :key="index"
            class="box max-w-[400px] shadow-lg py-8 px-9"
            :class="card.class"
          >
            <h3 class="text-xl font-semibold my-2">
              {{ card.title }}
            </h3>
            <p class="text-base text-gray-900 mb-4">
              {{ card.text }}
            </p>
            <a :href="card.seeMoreUrl" class="link flex items-center gap-2">
              See more
              <font-awesome-icon
                :icon="['fas', 'arrow-right']"
                class="w-4 h-4"
              />
            </a>
          </div>
        </div>
      </div>

      <div
        class="relative flex justify-center items-center w-full max-w-[900px] h-auto overflow-hidden"
      >
        <img
          src="/storage/images/home/decentralized_face_authentication_Youverse.jpg"
          alt="Decentralized Face Authentication Youverse"
          class="h-auto object-cover md:object-[30%] md:w-[120%] md:-translate-x-[20%] lg:w-[110%] lg:-translate-x-[10%] xl:w-full xl:translate-x-0"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cards: [
        {
          title: "Privacy-preserving",
          text: "No central databases, no breaches: decentralized authentication keeps data safe.",
          seeMoreUrl: "pricing",
          class: "mr-0 lg:mr-[300px] ",
        },
        {
          title: "Top-tier liveness detection",
          text: "State-of-the-art biometrics: 0% FAR, NIST top-tier, and iBeta compliant.",
          seeMoreUrl: "pricing",
          class: "mr-0 lg:mr-[200px]",
        },
        {
          title: "Decentralized",
          text: "Prioritizes data privacy and protects businesses from data breaches.",
          seeMoreUrl: "pricing",
          class: "mr-0 lg:mr-[100px]",
        },
        {
          title: "Plug and play",
          text: "Easily integrates into existing systems, accelerating time-to-market.",
          seeMoreUrl: "pricing",
          class: "mr-0",
        },
      ],
    };
  },
};
</script>
